import React, { Component } from 'react';
import { GenericSimpleButton, GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

let newLimit;

class TableRowItalicEdit extends Component {

    constructor(props) {
        super(props);
        this.state = { Valor: this.props.row.Valor, newLimit: true };
    }

    /**
     * 
     * @param {any} event
     */
    selectCombo(event) {
        this.props.modificacionNovedad(parseInt(event.target.value), this.props.novedad.Id, this.props.row.Id);
    }

    /**
     * 
     */
    aceptarCambios() {
        this.props.aceptarEdicion();
    }

    /**
     * 
     */
    cancel() {
        this.props.cancelEdicionNovedad(this.props.novedad.Id, this.props.row.Id);
    }

    /**
     * 
     */
    leaveLimite() {
        this.props.desaparicionLapizEdicion();
    }

    /**
     * 
     */
    editLimite() {
        this.props.comienzoDeEdicion(this.props.row.Id, this.props.novedad.ValorNovedad, this.props.novedad.ValorAnterior);
    }

    render() {
        let timeToNovedad = null;
        let drawName = null;
        let drawNovedad = null;
        let fecha = null;
        let hora = null;
        let name = this.props.row.Descripcion;
        let valor = this.props.row.Valor;
        let limiteCompra = this.props.data.limiteCompra;

        if (this.props.novedad !== undefined) {
            let valorNovedad = this.props.novedad.ValorNovedad;
            let valorAnterior = this.props.novedad.ValorAnterior;

            if (this.props.novedadEditado != undefined) {
                if (this.props.novedadEditado.edited) {
                    valor = this.props.novedadEditado.ValorNovedad;
                }
                else {
                    valor = valorNovedad;
                }
            } else {
                valor = valorNovedad;
            }

            let valorLimiteCompra = limiteCompra.find(x => x.Id == valor).Valor;
            valor = GlobalHelper.ConvertirNumeroMilesMillones(valorLimiteCompra);

            timeToNovedad = this.props.novedad.FechaHoraModificacion.replace("T", " ").replace("Z", "");
            fecha = timeToNovedad.substring(0, 10).split("-");
            hora = timeToNovedad.substring(16, 11);

            drawName = <div className="col-md-4">
                <label className="label-secondary">{name}</label>
            </div>

        } else {
            name = name + " :"

            drawName = <div className="col-md-4">
                <label className="label-secondary"><i>{name}</i></label>
            </div>
        }

        let buttonNode = null;
        let draw = null;
        if (this.props.editRow == true) {
            //Cargo el combo con los limites          
            var limites = this.props.data.limiteCompra.map((limite) => {
                return (
                    <GenericOption key={limite.Id} id={limite.Id} description={limite.Valor} />
                )
            })

            let novedad = this.props.data.novedadesCuentas.find(x => x.CuentaTarjetaId == this.props.data.selectedId);

            draw =
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-1">
                            <label className="label-secondary"><i>$</i></label>
                        </div>
                        <div className="col-md-11 no-padding-left">
                            <div className="row">
                                <div className="col-md-4">
                                    <GenericSelect
                                        id="limiteCuentaNovedadDistribucionLimite"
                                        className="form-control default-select"
                                        options={limites}
                                        value={novedad.ValorNovedad}
                                        onChange={(event) => this.selectCombo(event)}
                                    />

                                </div>
                                <div className="col-md-3">
                                    <GenericSimpleButton text="Listo" buttonClass="btn btn-cta" onClick={this.aceptarCambios.bind(this)} />
                                </div>
                                <div className="col-md-5">
                                    <GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary" onClick={this.cancel.bind(this)} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        }
        else {
            draw = <div className="col-md-6" onMouseLeave={this.leaveLimite.bind(this)}>
                <div className="row">
                    <div className="col-md-1 width-0">
                        <label className="label-secondary"><i>$</i></label>
                    </div>
                    <div className="col-md-4 no-padding-left">
                        <div className="container-distribution">
                            <label className="label-secondary hand color-azul-claro" onClick={this.editLimite.bind(this)} ><i>{valor}</i></label>
                            <span onClick={this.editLimite.bind(this)} className="ti-pencil hand" aria-hidden="true"></span>
                        </div>
                    </div>
                    <div className="col-md-7"></div>
                </div>
            </div>
        }

        return (
            <div>
                <div className="row">
                    <div className="col-md-2">
                    </div>
                    {drawName}
                    {draw}
                </div>
                {drawNovedad}
            </div>
        );
    }
}

export default TableRowItalicEdit